import * as dashboardTypes from './dashboardTypes';

const initialState = {
  userId: null,
  dashboardType: sessionStorage.getItem('dashboardType') || 'myData', // myData | allData,
  selectedMenu: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case dashboardTypes.SET_DASHBOARD_TYPE: {
      return {
        ...state,
        dashboardType: action.dashboardType,
      };
    }
    case dashboardTypes.SET_SELECTED_MENU_TYPE: {
      return {
        ...state,
        selectedMenu: action.flag,
      };
    }
    default: {
      return state;
    }
  }
};

export default dashboardReducer;
